import { render, staticRenderFns } from "./WithdrawSuccessModal.vue?vue&type=template&id=addd1266&scoped=true"
import script from "./WithdrawSuccessModal.vue?vue&type=script&lang=js"
export * from "./WithdrawSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawSuccessModal.vue?vue&type=style&index=0&id=addd1266&lang=css"
import style1 from "./WithdrawSuccessModal.vue?vue&type=style&index=1&id=addd1266&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addd1266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('addd1266')) {
      api.createRecord('addd1266', component.options)
    } else {
      api.reload('addd1266', component.options)
    }
    module.hot.accept("./WithdrawSuccessModal.vue?vue&type=template&id=addd1266&scoped=true", function () {
      api.rerender('addd1266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Modal/WithdrawSuccessModal.vue"
export default component.exports